import {
  Color,
  SphereGeometry,
  ShaderMaterial,
  Mesh,
  DoubleSide,
  AdditiveBlending,
} from 'three';

import { Entity } from './entity.js';

import fragmentAround from '../../../shaders/atmAround/fragment.glsl';
import vertexAround from '../../../shaders/atmAround/vertex.glsl';

import { PulsarNebula } from '../groupsEntities/windNebula.js';

import { showInfoPanel } from '../ui.js';

import {sceneManager } from '../script.js';

import { attrNeutron, attrNebNeutron } from '../configEntities/groupsAttr.js';
import { createJets} from '../utils/jets.js'
export class Neutron extends Entity {
  constructor(size, orbitRadius, axialTilt, orbitInclin, speedTrans, speedRot, eccentricity, label, centerElement) {

    super(centerElement, size, null, orbitRadius, axialTilt, orbitInclin, speedTrans, speedRot, eccentricity,0,0, label);

    
    this.jets = createJets(this,600, attrNeutron, attrNeutron.jetConfig)

    this.infoIcon.addEventListener('click', (evt) => {
      evt.stopPropagation();
      showInfoPanel(label);
    });

    this.nebula = new PulsarNebula(600, this, {maxRadius: 12 }, attrNebNeutron, true)

    this.distSpace = 0.4
    this.scaleSpace = 4

    this.initElements(sceneManager.scene);
  }
  initElements(scene) {
    this.matAround = new ShaderMaterial({
      transparent: true,
      uniforms: {
        u_color: { value: new Color(0xcfcaff) },

      },
      vertexShader: vertexAround,
      fragmentShader: fragmentAround,
      blending: AdditiveBlending,
      depthTest: true,
      depthWrite: false,
      side: DoubleSide
    });
   
    this.geoAround = new SphereGeometry(this.size * 2, 64, 64);
    this.meshAround = new Mesh(this.geoAround, this.matAround);
    scene.add(this.meshAround);
    this.mesh.add(this.meshAround);

  }
  addMeshToScene(mesh) {
    sceneManager.scene.add(mesh);
    this.mesh.add(mesh);
  }
}
